import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import { useHagerBridgePermissions } from 'src/Libs/e-mobility/shared'
import { useMediaQuery, useTheme } from '@mui/material'
import { useFetchTariffs } from '../api/use-fetch-tariffs'
import { TariffSkeleton } from './TariffSkeleton'
import { TariffsTableDesktopView } from './TariffsTableDesktopView'
import { TariffsTableMobileView } from './TariffsTableMobileView'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'

interface TariffsProps {
  installationId: number
}

/** This component represents Tariffs Page overview */
export const Tariffs: React.FC<TariffsProps> = ({ installationId }) => {
  const { t } = useCustomTranslation()
  const { tariffResponse, isLoading, isError } = useFetchTariffs(installationId)
  const { permissions } = useHagerBridgePermissions()

  const theme = useTheme()
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'))

  if (isLoading) {
    return <TariffSkeleton />
  }

  if (isError) {
    return <ErrorMessage title={t('emobility.tariffs.error-message')} />
  }

  return (
    <>
      {permissions.tourGuidePermissions.viewTourGuide && <BannerQueue location={BannerLocations.EmobilityTour} />}
      <BannerQueue location={BannerLocations.EmobilityCountryInfoMissingTariffs} />

      {isMobileOrTablet ? (
        <TariffsTableMobileView
          tariffs={tariffResponse.tariffs}
          installationId={installationId}
          dynamicTariffActivated={tariffResponse.dynamicTariffActivated}
        />
      ) : (
        <TariffsTableDesktopView
          tariffs={tariffResponse.tariffs}
          installationId={installationId}
          dynamicTariffActivated={tariffResponse.dynamicTariffActivated}
        />
      )}
    </>
  )
}
